<template>
  <div class="tpp-page">
    <nearby-housekeeping-ops-nav active-path="/pages/tpp/nearby-housekeeping/precheck" :platform-id="platformId" />
    <section class="tpp-panel" v-loading="loading">
      <div class="tpp-panel__head"><div><h2 class="tpp-panel__title">发布预检</h2><p class="tpp-muted">正式契约和真实到账完成前，不开放生产商品交易。</p></div><el-button size="small" @click="load">重新检查</el-button></div>
      <el-alert :title="result.ready ? '可以发布' : '尚未满足发布条件'" :type="result.ready ? 'success' : 'warning'" :closable="false" show-icon />
      <ul>
        <li v-for="item in result.missingItems || []" :key="item">{{ item }}</li>
      </ul>
    </section>
  </div>
</template>
<script>
import NearbyHousekeepingOpsNav from './nearbyHousekeepingNav.vue'
import { nearbyHousekeepingOpsMixin } from './nearbyHousekeepingOpsMixin'
import { getNearbyHousekeepingPrecheck, nhPayload } from '@/api/tpp/nearbyHousekeepingOpsApi'
import '../tpp.scss'
export default {
  name: 'NearbyHousekeepingPrecheck',
  components: { NearbyHousekeepingOpsNav },
  mixins: [nearbyHousekeepingOpsMixin],
  data() { return { loading: false, result: {} } },
  async created() { if (await this.ensureNearbyHousekeepingPlatform()) this.load() },
  methods: {
    async load() { this.loading = true; try { this.result = nhPayload(await getNearbyHousekeepingPrecheck({ platformId: this.platformId })) || {} } catch (e) { this.$message.error(e.message || '预检失败') } finally { this.loading = false } }
  }
}
</script>
